import { createConfigParametersRepository } from '..';
import { createRuntimeState } from '../state';

export const checkThirdPartyTrackingStorageInit = () => {
  const { getTrackingStorageClient, getGenericParameters } =
    createConfigParametersRepository();
  const storageClient = getTrackingStorageClient();
  const { getRuntimeState } = createRuntimeState();
  const { isStorageInitialized } = getRuntimeState();
  if (isStorageInitialized) {
    return;
  }
  const genericParameters = getGenericParameters();
  storageClient?.initThirdParty(genericParameters?.visitID);
};
